export default "__VITE_ASSET__4faa1cff__"